declare namespace $ {

	type $bog_blitz_lobby_game_timer__round_start_bog_blitz_lobby_game_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['round_start'] >
		,
		ReturnType< $bog_blitz_lobby_game_timer['round_start'] >
	>
	type $bog_blitz_lobby_game_timer__duration_bog_blitz_lobby_game_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['duration'] >
		,
		ReturnType< $bog_blitz_lobby_game_timer['duration'] >
	>
	type $bog_blitz_lobby_game_timer__paused_at_bog_blitz_lobby_game_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['paused_at'] >
		,
		ReturnType< $bog_blitz_lobby_game_timer['paused_at'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_4 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['host_controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_5 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['state_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_image__uri_bog_blitz_lobby_game_6 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['question_image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['current_question_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['answer_views'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_9 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['countdown_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_blitz_lobby_game_timer__round_start_bog_blitz_lobby_game_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['round_start'] >
		,
		ReturnType< $bog_blitz_lobby_game_timer['round_start'] >
	>
	type $bog_blitz_lobby_game_timer__duration_bog_blitz_lobby_game_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['duration'] >
		,
		ReturnType< $bog_blitz_lobby_game_timer['duration'] >
	>
	type $bog_blitz_lobby_game_timer__paused_at_bog_blitz_lobby_game_12 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['paused_at'] >
		,
		ReturnType< $bog_blitz_lobby_game_timer['paused_at'] >
	>
	type $bog_blitz_lobby_game_leaderboard__players_dict_bog_blitz_lobby_game_13 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['players_dict'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard['players_dict'] >
	>
	type $bog_blitz_lobby_game_leaderboard__my_lord_str_bog_blitz_lobby_game_14 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['my_lord_str'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard['my_lord_str'] >
	>
	type $bog_blitz_lobby_game_leaderboard__is_host_bog_blitz_lobby_game_15 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['is_host'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard['is_host'] >
	>
	type $bog_blitz_lobby_game_leaderboard__players_dict_bog_blitz_lobby_game_16 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['players_dict'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard['players_dict'] >
	>
	type $bog_blitz_lobby_game_leaderboard__my_lord_str_bog_blitz_lobby_game_17 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['my_lord_str'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard['my_lord_str'] >
	>
	type $bog_blitz_lobby_game_leaderboard__is_host_bog_blitz_lobby_game_18 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['is_host'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard['is_host'] >
	>
	type $bog_blitz_lobby_game_reactboard__players_dict_bog_blitz_lobby_game_19 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['players_dict'] >
		,
		ReturnType< $bog_blitz_lobby_game_reactboard['players_dict'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_20 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['countdown_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_blitz_lobby_game_21 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['pause_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_lobby_game_22 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['pause_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_blitz_lobby_game_23 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['resume_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_lobby_game_24 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['resume_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_bog_blitz_lobby_game_25 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['next_label'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_lobby_game_26 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['next_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_string__hint_bog_blitz_lobby_game_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_blitz_lobby_game_28 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['text_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_bog_blitz_lobby_game_29 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['text_input_enabled'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__submit_bog_blitz_lobby_game_30 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['text_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_31 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['reveal_correct_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_bog_blitz_lobby_game_32 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['submit_label'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_lobby_game_33 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['submit_answer'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_bog_blitz_lobby_game_34 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['submit_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $bog_blitz_lobby_game_option__selected_bog_blitz_lobby_game_35 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['option_selected'] >
		,
		ReturnType< $bog_blitz_lobby_game_option['selected'] >
	>
	type $bog_blitz_lobby_game_option__correct_bog_blitz_lobby_game_36 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['option_correct'] >
		,
		ReturnType< $bog_blitz_lobby_game_option['correct'] >
	>
	type $bog_blitz_lobby_game_option__enabled_bog_blitz_lobby_game_37 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['option_enabled'] >
		,
		ReturnType< $bog_blitz_lobby_game_option['enabled'] >
	>
	type $bog_blitz_lobby_game_option__title_bog_blitz_lobby_game_38 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['option_text'] >
		,
		ReturnType< $bog_blitz_lobby_game_option['title'] >
	>
	type $bog_blitz_lobby_game_option__image_uri_bog_blitz_lobby_game_39 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['option_image_uri'] >
		,
		ReturnType< $bog_blitz_lobby_game_option['image_uri'] >
	>
	type $bog_blitz_lobby_game_option__click_bog_blitz_lobby_game_40 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game['option_click'] >
		,
		ReturnType< $bog_blitz_lobby_game_option['click'] >
	>
	export class $bog_blitz_lobby_game extends $mol_view {
		game_content( ): readonly(any)[]
		pause_label( ): string
		pause_click( next?: any ): any
		resume_label( ): string
		resume_click( next?: any ): any
		next_label( ): string
		next_click( next?: any ): any
		Timer( ): $bog_blitz_lobby_game_timer
		host_controls( ): readonly(any)[]
		Host_controls( ): $mol_view
		State( ): $mol_paragraph
		question_image_uri( ): string
		Question_image( ): $mol_image
		Question( ): $mol_paragraph
		answer_views( ): readonly(any)[]
		Answer_area( ): $mol_view
		countdown_content( ): readonly(any)[]
		Countdown( ): $mol_view
		text_draft( next?: string ): string
		text_input_enabled( ): boolean
		text_submit( next?: any ): any
		Leaderboard_timer( ): $bog_blitz_lobby_game_timer
		my_lord_str( ): string
		Leaderboard( ): $bog_blitz_lobby_game_leaderboard
		Final( ): $bog_blitz_lobby_game_leaderboard
		Reactions_board( ): $bog_blitz_lobby_game_reactboard
		submit_label( ): string
		submit_answer( next?: any ): any
		submit_enabled( ): boolean
		option_selected( id: any): string
		option_correct( id: any): string
		option_enabled( id: any): boolean
		option_text( id: any): string
		option_image_uri( id: any): string
		option_click( id: any, next?: any ): any
		land_id( ): string
		session( ): any
		quiz_data( ): any
		game_state( ): string
		current_question( ): any
		current_question_text( ): string
		my_player( ): any
		my_answers( ): any
		is_host( ): boolean
		paused_at( ): number
		manual_mode( ): boolean
		state_reading( ): string
		state_answering( ): string
		state_reveal( ): string
		state_leaderboard( ): string
		state_final( ): string
		state_paused( ): string
		state_label( ): string
		option_keys( ): readonly(string)[]
		round_start( ): number
		duration( ): number
		total_questions( ): number
		current_question_index( ): number
		players_dict( ): any
		countdown_number( ): number
		countdown_text( ): string
		Countdown_number( ): $mol_paragraph
		sub( ): ReturnType< $bog_blitz_lobby_game['game_content'] >
		Pause_button( ): $mol_button_minor
		Resume_button( ): $mol_button_minor
		Next_button( ): $mol_button_major
		question_type( ): string
		question_content( ): readonly(any)[]
		Answer_input( ): $mol_string
		leaderboard_content( ): readonly(any)[]
		final_content( ): readonly(any)[]
		reveal_correct_text( ): string
		Reveal_correct( ): $mol_paragraph
		Submit_answer( ): $mol_button_major
		Option( id: any): $bog_blitz_lobby_game_option
	}
	
}

//# sourceMappingURL=game.view.tree.d.ts.map